<template>
    <div class="settings-page container-fluid page-card admin-weflix-settings weeduc-admin-page">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    title="Configurações"
                    subtitle="Ajuste as configurações gerais, a segurança de acesso e os domínios do site Weflix."
                    :hasMargin="false"
                />
            </div>
        </header>

        <div class="settings-page__body">
            <section class="settings-section section config-form primary active">
                <General />
            </section>
            <section class="settings-section section config-form primary active">
                <Security />
            </section>
            <section class="settings-section section config-form primary active">
                <Domain />
            </section>
        </div>
    </div>
</template>

<script>
    import General from '@/components/Weflix/Config/genereal.vue';
    import Security from '@/components/Weflix/Config/security.vue';
    import Domain from '@/components/Weflix/Config/domain.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';
    import { mapActions } from 'vuex';

    export default {
        data() {
            return {
                hassaved: false,
                openmodalmodule: false,
            };
        },
        props: {},
        components: {
            General,
            Security,
            Domain,
            TitlePage,
        },
        methods: {
            ...mapActions(['storeToken']),
            settoken(token) {
                this.storeToken({ token: token });
            },
        },
        created() {},
    };
</script>

<style scoped>
    @import url(./global.css);
    @import url('@/css/weeduc/admin/dashboard-weflix-shell.css');

    .settings-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
        text-align: left;
    }

    .settings-page :deep(.weeduc-admin-page__header-lead .titlelayoutGeneric) {
        border-bottom: none;
        padding-bottom: 0;
    }

    .settings-page :deep(.weeduc-admin-page__header-lead .titlelayoutGeneric h3) {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0 0 0.35rem;
        color: #1a1d26;
    }

    .settings-page :deep(.weeduc-admin-page__header-lead .titlelayoutGeneric small) {
        display: block;
        margin-top: 0;
        color: #5c6370;
        line-height: 1.45;
    }

    .settings-page__body {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        max-width: none;
        margin: 0;
        padding: 16px 24px 36px;
        height: auto;
        overflow: visible;
        box-sizing: border-box;
        background: #f4f5f8;
    }

    .settings-section.section.config-form.primary,
    .settings-section.section.config-form.primary.active {
        display: block !important;
        height: auto !important;
        overflow: visible !important;
        background: transparent;
        box-shadow: none;
    }

    @media (max-width: 640px) {
        .settings-page__body {
            padding: 12px 12px 28px;
        }
    }
</style>

<style>
.weflix-admin-dashboard .content.dashboard:has(.settings-page) {
    overflow: visible;
    height: auto;
    min-height: calc(100vh - 88px);
}
</style>

